export const SearchIcon: React.FC = ({}) => {
    return(
      <svg xmlns="http://www.w3.org/2000/svg" width="15.971" height="15.971" viewBox="0 0 15.971 15.971">
        <path id="search-lupa" d="M7.557,13.045h.721l.256-.247a5.945,5.945,0,1,1,.639.639l-.247.256v.721L4.361,18.971,3,17.611Zm5.479,0A4.109,4.109,0,1,0,8.926,8.936,4.1,4.1,0,0,0,13.036,13.045Z" transform="translate(-3 -3)" fill="#114D88"/>
      </svg>
  )
}